export const footerDataKinhDoanh = [
  {
    id: 'p2',
    title: 'Ý tưởng kinh doanh',
    href: '/y-tuong-kinh-doanh',
  },
  {
    id: 'p1',
    title: 'Kinh nghiệm kinh doanh',
    href: '/kinh-nghiem-kinh-doanh',
    items: [
      {
        id: 'p1c1',
        name: 'Kinh nghiệm mở cửa hàng',
        href: '/kinh-nghiem-kinh-doanh/kinh-nghiem-mo-cua-hang',
        external: false,
      },
      {
        id: 'p1c2',
        name: 'Bán hàn online',
        href: '/kinh-nghiem-kinh-doanh/ban-hang-online',
        external: true,
      },
      {
        id: 'p1c3',
        name: 'Kinh doanh trên Facebook',
        href: '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-facebook',
        external: false,
      },
      {
        id: 'p1c4',
        name: 'Kinh doanh trên Shopee',
        href: '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-shopee',
        external: false,
      },
      {
        id: 'p1c5',
        name: 'Kinh doanh trên TikTok Shop',
        href: '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-tiktok-shop',
        external: true,
      },
      {
        id: 'p1c6',
        name: 'Kinh doanh trên Lazada',
        href: '/kinh-nghiem-kinh-doanh/kinh-doanh-tren-lazada',
        external: false,
      },
      {
        id: 'p1c7',
        name: 'Kiến thức marketing',
        href: '/kinh-nghiem-kinh-doanh/kien-thuc-marketing',
        external: false,
      },
    ],
  },
  {
    id: 'p3',
    title: 'Nguồn hàng',
    href: '/nguon-hang',
    items: [
      {
        id: 'p3c1',
        name: 'Chợ đầu mối',
        href: '/nguon-hang/cho-dau-moi',
        external: false,
      },
      {
        id: 'p3c2',
        name: 'Cách nhập hàng',
        href: '/nguon-hang/cach-nhap-hang',
        external: false,
      },
    ],
  },
  {
    id: 'p4',
    href: '/kho-bai',
    title: 'Kho bãi',
  },
];
